import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
// import { PageHeading } from "./PageHeader/PageHeader";

export const getFlightInfoDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  pageContents: [
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      usedFileType: "image/*",
      type: "image",
      name: "image",
      formType: "file",
      label: "Image",
      placeholder: "Upload Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Title (EN)",
      fieldValue: "english_title",
      className: "col-span-6",
      type: "text",
      name: "english_title",
      formType: "input",
      label: "English Title",
      placeholder: "Enter English Title",
      validation: { required: "English Title is required" },
    },
    {
      fieldName: "Title (MS)",
      fieldValue: "malay_title",
      className: "col-span-6",
      type: "text",
      name: "malay_title",
      formType: "input",
      label: "Malay Title",
      placeholder: "Enter Malay Title",
      // validation: { required: "Malay Title is required" },
    },
    {
      fieldName: "Title (ZH)",
      fieldValue: "mandarin_title",
      className: "col-span-6",
      type: "text",
      name: "mandarin_title",
      formType: "input",
      label: "Mandarin Title",
      placeholder: "Enter Mandarin Title",
      // validation: { required: "Mandarin Title is required" },
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "description_english",
      className: "col-span-6",
      type: "text",
      name: "description_english",
      formType: "textarea",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "description_malay",
      className: "col-span-6",
      type: "text",
      name: "description_malay",
      formType: "textarea",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Malay Description is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "description_mandarin",
      className: "col-span-6",
      type: "text",
      name: "description_mandarin",
      formType: "textarea",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Mandarin Description is required" },
    },
    {
      fieldName: "Redirect URL",
      fieldValue: "redirect_url_english",
      className: "col-span-6",
      type: "text",
      name: "redirect_url_english",
      formType: "input",
      label: "Redirect URL (EN)",
      placeholder: "Enter Redirect URL",
      validation: { required: "Redirect URL is required" },
    },
    // {
    //   fieldName: "Redirect URL (MS)",
    //   fieldValue: "redirect_url_malay",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "redirect_url_malay",
    //   formType: "input",
    //   label: "Redirect URL (MS)",
    //   placeholder: "Enter Redirect URL (MS)",
    //   // validation: { required: "Redirect URL (MS) is required" },
    // },
    // {
    //   fieldName: "Redirect URL (ZH)",
    //   fieldValue: "redirect_url_mandarin",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "redirect_url_mandarin",
    //   formType: "input",
    //   label: "Redirect URL (ZH)",
    //   placeholder: "Enter Redirect URL (ZH)",
    //   // validation: { required: "Redirect URL (ZH) is required" },
    // },

    // {
    //   fieldName: "Published",
    //   fieldValue: "published",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "published",
    //   formType: "checkbox",
    //   label: "Published",
    //   placeholder: "Enter Published",
    // },
  ],

  FlightInfoHeaders: [
    {
      fieldName: "Page Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: "image/*",
      label: "Page Banner Image",
      placeholder: "Upload Page Banner Image",
      validation: { required: "At least one Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (English)",
      validation: { required: "At least one title is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (Malay)",
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (Mandarin)",
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (English)",
      // validation: { required: "At least one Description is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (Malay)",
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (Mandarin)",
    },
  ],
};
